var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("CompassDialog", {
    staticClass: "popup-mass-edit-prefs",
    attrs: {
      visible: _vm.showModal,
      size: "small",
      title: _vm.$t.__("forms.PopupMassEditPrefs.edit_preferences")
    },
    on: {
      "update:visible": function($event) {
        _vm.showModal = $event
      },
      closed: function($event) {
        return _vm.$emit("close")
      }
    },
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function() {
          return [
            _c(
              "div",
              { staticClass: "dialog__default" },
              [
                _c("CompassAlert", {
                  attrs: {
                    type: "informative",
                    description: _vm.$t.__(
                      "forms.PopupMassEditPrefs.onced_saved"
                    ),
                    showIcon: false,
                    action: {},
                    showClose: false
                  }
                }),
                _vm._v(" "),
                _c(
                  "div",
                  [
                    _vm._l(_vm.prefsSelected, function(pref, key) {
                      return _c(
                        "div",
                        { key: key },
                        [
                          key >= 1 ? _c("el-divider") : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "p",
                            {
                              staticClass:
                                "typographies-paragraph-medium-regular"
                            },
                            [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(
                                    _vm.$l10n.n__("Préférence à mettre à jour")
                                  ) +
                                  "\n                        "
                              ),
                              _vm.prefsSelected.length > 1
                                ? _c("i", {
                                    staticClass:
                                      "icon-trash fright gray-60 hover-gray-80",
                                    on: {
                                      click: function($event) {
                                        return _vm.onRemovePref(key, pref)
                                      }
                                    }
                                  })
                                : _vm._e()
                            ]
                          ),
                          _vm._v(" "),
                          _c("dropdown-search", {
                            staticClass: "mb-3",
                            attrs: { pref: pref },
                            on: {
                              onMetaSelected: function(meta) {
                                return _vm.onMetaSelected(key, pref, meta)
                              }
                            },
                            model: {
                              value: _vm.prefsForDropDown,
                              callback: function($$v) {
                                _vm.prefsForDropDown = $$v
                              },
                              expression: "prefsForDropDown"
                            }
                          }),
                          _vm._v(" "),
                          pref.name
                            ? _c("pref-mass-edit-input", {
                                attrs: {
                                  pref: pref,
                                  metas: _vm.metas,
                                  error: _vm.errors
                                }
                              })
                            : _vm._e()
                        ],
                        1
                      )
                    }),
                    _vm._v(" "),
                    _vm.prefsSelected.every(function(item) {
                      return item.name
                    }) &&
                    Object.keys(_vm.prefsForDropDown).length !==
                      _vm.prefsSelected.length
                      ? _c("text-icon", {
                          staticClass: "mt-5",
                          attrs: { icon: "icon-plus", color: "primary-50" },
                          nativeOn: {
                            click: function($event) {
                              return _vm.onAddPref($event)
                            }
                          }
                        })
                      : _vm._e()
                  ],
                  2
                )
              ],
              1
            )
          ]
        },
        proxy: true
      },
      {
        key: "footer",
        fn: function() {
          return [
            _c(
              "div",
              { staticClass: "dialog__footer" },
              [
                _c("CompassButton", {
                  attrs: {
                    label: _vm.$t.__("common.actions.cancel"),
                    type: "secondary"
                  },
                  on: {
                    click: function($event) {
                      return _vm.$emit("close")
                    }
                  }
                }),
                _vm._v(" "),
                _c("CompassButton", {
                  staticClass: "ml-3",
                  attrs: {
                    label: _vm.$t.__("common.actions.save"),
                    type: "primary",
                    disabled: !_vm.prefsSelected.every(function(item) {
                      return item.name
                    })
                  },
                  on: {
                    click: function($event) {
                      return _vm.save()
                    }
                  }
                })
              ],
              1
            )
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }